// -------------------
// Feedback Modal Form
$(document).ready(function () {
  var iSecondsThreshold = parseInt($("#HSIThreshold input").val());

  (function () {
    "use strict";

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false,
      );
    });
  })();

  //------------------------------------
  // Check for error messages (postback)
  var errorMessages = $("#feedbackModal .EditingFormErrorLabel");
  if (errorMessages.length > 0) {
    var i = parseInt($(".hsiCounter").val());

    if (i < iSecondsThreshold) {
      i += 5;
      $(".hsiCounter").val(i);
      //console.log(i.toString());
    }
  }

  //-------------------------------
  // Set focus to modal when opened
  $("#feedbackModal").on("shown.bs.modal", function () {
    $("#feedbackModal").trigger("focus");
    var i = parseInt($(".hsiCounter").val());
  });

  //---------------------------------------------
  // For spam prevention: Timer for feedback form
  // Use Hidden Second Integer Counter

  // On form submit: check timer, hide modal if too fast
  //$('form').on('submit', function (e) {
  //if ($('#DetailedDescriptionOfIssues textarea').val().length > 0) {
  //    e.stopPropagation();
  //    var i = parseInt($('.hsiCounter').val());
  //    //console.log('Check this out! HSIC: ' + $('.hsiCounter').val());
  //    if (i >= iSecondsThreshold) {
  //        return true
  //    } else {
  //        $('#feedbackModal').modal('hide');
  //        return false;
  //    }
  //}
  //});

  // Increment counter
  function fCounter() {
    var i = parseInt($(".hsiCounter").val());

    if (i < iSecondsThreshold) {
      i += 1;
      $(".hsiCounter").val(i);
      //console.log(i.toString());
    } else {
      clearInterval(siCounter);
    }
  }

  // Timer interval
  var siCounter = setInterval(fCounter, 1000);
});

function CheckBoxes() {
  var checkboxes = document.getElementsByClassName("required-checkbox");
  var checked = false;
  Array.prototype.forEach.call(checkboxes, function (checkbox) {
    if (checkbox.checked) {
      checked = true;
    }
  });
  return checked;
}

function ValidateCheckBoxes() {
  var error = document.getElementById("checkbox-error");
  let test = CheckBoxes();
  if (test) {
    error.style.display = null;
    return true;
  } else {
    error.style.display = "block";
    return false;
  }
}

function ChecboxesSetValidationOnChange() {
  var checkboxes = document.getElementsByClassName("required-checkbox");
  Array.prototype.forEach.call(checkboxes, function (checkbox) {
    checkbox.addEventListener("change", (event) => {
      ValidateCheckBoxes();
    });
  });
}

function PhoneSetValidationOnChange() {
  var inputs = document.getElementsByClassName("phone-number");
  Array.prototype.forEach.call(inputs, function (input) {
    input.addEventListener("keyup", (event) => {
      ValidateNumbers();
    });
  });
}

function ValidateNumbers() {
  var phone1 = document.getElementById("Phone1");
  var phone2 = document.getElementById("Phone2");
  var phone3 = document.getElementById("Phone3");
  var pattern = /[0-9]+$/;
  var error = document.getElementById("phone-error");
  //is-invalid
  if (
    (phone1.value == "" && phone2.value == "" && phone3.value == "") ||
    (pattern.test(phone1.value) &&
      pattern.test(phone2.value) &&
      pattern.test(phone3.value))
  ) {
    error.style.display = null;
    return true;
  } else {
    error.style.display = "block";
    return false;
  }
}

function SubmitFeedbackForm(e) {
  e.preventDefault();

  var form = document.forms["feedbackForm"];

  if (!form.checkValidity() | !ValidateCheckBoxes() | !ValidateNumbers()) {
    ChecboxesSetValidationOnChange();
    PhoneSetValidationOnChange();
  } else {
    var formData = new FormData(form);
    var object = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });

    var json = JSON.stringify(object);
    $.ajax({
      type: "POST",
      url: "/FeedbackFormApi/SetDataToBizForm",
      data: {
        json: json,
      },
      dataType: "text",
    })
      .done(function (result) {
        document.getElementById("feedback-form-body").innerHTML = result;
      })
      .fail(function (xhr) {
        console.log(
          "error : " +
            xhr.status +
            " - " +
            xhr.statusText +
            " - " +
            xhr.responseText,
        );
      });
  }
}

(function () {
  let feedbackModalPromise = null;

  function injectFeedbackVerificationToken(modalElement) {
    if (!modalElement) {
      return;
    }

    const token = modalElement.getAttribute("data-request-verification-token");
    if (!token) {
      return;
    }

    const forms = modalElement.querySelectorAll("form");
    forms.forEach((form) => {
      let tokenInput = form.querySelector(
        "input[name='__RequestVerificationToken']",
      );
      if (!tokenInput) {
        tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "__RequestVerificationToken";
        form.appendChild(tokenInput);
      }

      tokenInput.value = token;
    });
  }

  function loadFeedbackModal() {
    const existingModal = document.getElementById("feedbackModal");
    if (existingModal) {
      return Promise.resolve(existingModal);
    }

    if (feedbackModalPromise) {
      return feedbackModalPromise;
    }

    const pageUrl = encodeURIComponent(window.location.href.split("#")[0]);

    feedbackModalPromise = fetch(`/FeedbackModal/Modal?pageUrl=${pageUrl}`, {
      method: "GET",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Failed to load feedback modal. Status: ${response.status}`,
          );
        }

        return response.text();
      })
      .then((html) => {
        const host = document.getElementById("feedback-modal-host");
        host.innerHTML = html;

        const modal = document.getElementById("feedbackModal");
        window.kentico.updatableFormHelper.updateForm(
          modal.querySelector("form"),
        );
        injectFeedbackVerificationToken(modal);

        return modal;
      })
      .finally(() => {
        feedbackModalPromise = null;
      });

    return feedbackModalPromise;
  }

  document.addEventListener("DOMContentLoaded", function () {
    loadFeedbackModal().catch((error) => console.error(error));
  });

  document.addEventListener("click", function (event) {
    const trigger = event.target.closest(
      "[data-target='#feedbackModal'], a[href='#feedbackModal']",
    );
    if (!trigger) {
      return;
    }

    event.preventDefault();

    loadFeedbackModal()
      .then((modal) => {
        if (window.jQuery && modal) {
          window.jQuery(modal).modal("show");
        }
      })
      .catch((error) => console.error(error));
  });
})();

function updateVerificationTokens(newInput) {
  if (!newInput) {
    return;
  }

  var inputs = document.querySelectorAll(
    "form input[name='__RequestVerificationToken']",
  );
  inputs.forEach(function (input) {
    input.outerHTML = newInput;
  });
}
